module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-energy-university.738b0eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-energy-university.png
// module id = L4QV
// module chunks = 0